import type React from "react";
import { clsx } from "clsx";
import { Link } from "react-router";
import { Button } from "../../ui/button";

export const LandingHeaderMenuItem = ({
  href = "#",
  label = "",
  type = "link",
  onClick,
  variant = "primary",
  className,
  children,
}: {
  href?: string;
  label?: string | React.ReactNode;
  type?: "button" | "link" | "icon-button";
  onClick?: () => void;
  variant?: "primary" | "secondary" | "ghost";
  className?: string;
  children?: React.ReactNode;
}) => {
  if (type === "button" || type === "icon-button") {
    return (
      <Button
        asChild
        onClick={onClick}
        variant={variant}
        className={clsx(
          type === "icon-button" && "rounded-full p-2",
          className,
        )}
      >
        {href.startsWith("#") ? (
          <a href={href}>{children || label}</a>
        ) : (
          <Link to={href}>{children || label}</Link>
        )}
      </Button>
    );
  }

  const isHashLink = href.startsWith("#");
  if (isHashLink) {
    return (
      <a
        href={href}
        className={clsx(
          "transition-colors font-medium",
          variant === "primary"
            ? "text-black dark:text-gray-200 hover:text-primary-500 dark:hover:text-primary-500"
            : "text-black dark:text-gray-200 hover:text-secondary-500 dark:hover:text-secondary-500",
          className,
        )}
        onClick={onClick}
      >
        {children || label}
      </a>
    );
  }

  return (
    <Link
      to={href}
      className={clsx(
        "transition-colors font-medium",
        variant === "primary"
          ? "text-black dark:text-gray-200 hover:text-primary-500 dark:hover:text-primary-500"
          : "text-black dark:text-gray-200 hover:text-secondary-500 dark:hover:text-secondary-500",
        className,
      )}
      onClick={onClick}
    >
      {children || label}
    </Link>
  );
};
